import React, { Component } from 'react';
import {
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CSpinner,
    CCol,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CRow,
    CFormCheck,
    CProgress,
    CProgressBar,
    CFormSelect,
    CFormLabel} from '@coreui/react'
import {
    cilPencil,
    cilSearch,
    cilBan,
    cilSend,
    cilReload,
    cilCloudDownload} from '@coreui/icons'
import PageHeader from 'src/components/PageHeader'
import AppButton from 'src/components/AppButton'
import TableActions from '../../components/TableActions'
import ServerConnector from 'src/ServerConnector'
import { replaceEmpty, urlDecode } from 'src/util/StringUtil';
import Pagination from 'src/components/Pagination';
import { rowsPerPage } from 'src/data/Data';

class MessagesList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            spinner: false,
            isDataLoading: false,
            dataList: [],
            total_rows: 0,
            page_number: 0,
            isLoadMore: true,
            responsePopup: {
                dataList: [],
                progressData: [],
                receipientList: [],
                totalProgress: 0,
                show: false,
                messageSeq: -1,
                messageType: "",
                selectedReceipient: ""
            }
        };
    }

    componentDidMount() {
        this.loadData(0)
    }

    loadData(startRow) {
        this.setState({
            spinner: true,
            isDataLoading: true
        });
        let connector = new ServerConnector();
        let dataMap = {
            _action_code: "GET_ALL_MESSAGES",
            page_seq: String(0),
            _start_row: String(startRow),
            _rows_page : String(rowsPerPage),
        }

        connector.postData(dataMap, (data) => { // success

            var dataList = this.state.dataList;
            if (this.state.page_number == 0) {
                dataList = [];
            }

            for (var i=0;i<data.data.length;i++) {
                dataList.push(data.data[i]);
            }

            this.setState({
                spinner: false,
                isDataLoading: false,
                dataList: dataList,
                total_rows: data._total_rows
            });
        }, (err_cd, msg, data) => { // failure
            this.setState({
                spinner: false,
                isLoadMore: false
            });
        })
    }

    confirmDeleteMessage(messageSeq) {

        var msg = "Do you want to delete this Message?";

        this.props.showConfirmation(
            "Confirmation",
            msg,
            "Yes",
            "No",
            null,
            () => { this.deleteMessage(messageSeq) }
        )
    }

    deleteMessage(messageSeq) {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "DELETE_GROUP_MESSAGE",
            "message_seq": messageSeq,
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            this.props.showAlert("Success", data.msg, "Ok", null, () => {

                this.setState({page_number: 0}, () => {this.loadData(0)})
            });
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    loadResponse(messageSeq, messageType, invokeType, setSeq) {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap = {
            "_action_code": "GET_MESSAGE_RESPONSES",
            "message_seq": messageSeq,
        }

        if (setSeq != -1 && setSeq.length > 0) {
            dataMap["set_seq"] = setSeq;
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            var responsePopup = this.state.responsePopup;
            responsePopup.dataList = data.data;
            responsePopup.progressData = [];
            responsePopup.totalProgress = 0;
            responsePopup.show = true;
            responsePopup.messageSeq = messageSeq;
            responsePopup.messageType = messageType;
            this.setState({responsePopup: responsePopup});

            if (messageType == "MSG_POLL") {
                this.loadPollMessageReport(messageSeq, messageType, invokeType, setSeq);
            }
            else {

                if (invokeType == "initial") {
                    this.loadMessageReceipient(messageSeq);
                }
            }
            
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            if (invokeType == "initial") {
                this.props.showAlert("Error", msg, "Ok", null, null);
            }
            else {
                var responsePopup = this.state.responsePopup;
                responsePopup.dataList = [];
                this.setState({responsePopup: responsePopup});
                this.loadPollMessageReport(messageSeq, messageType, invokeType, setSeq);
            }
        });
    }

    loadPollMessageReport(messageSeq, messageType, invokeType, setSeq) {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap = {
            "_action_code": "GET_POLL_MESSAGE_REPORT",
            "message_seq": messageSeq,
        }
        if (setSeq != -1 && setSeq.length > 0) {
            dataMap["set_seq"] = setSeq;
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            var totalProgress = 0;
            for (var i=0;i<data.data.length;i++) {
                totalProgress += data.data[i].count;
            }

            var responsePopup = this.state.responsePopup;
            responsePopup.progressData = data.data;
            responsePopup.totalProgress = totalProgress;
            this.setState({responsePopup: responsePopup});
            if (invokeType == "initial") {
                this.loadMessageReceipient(messageSeq);
            }
            
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
            if (invokeType == "initial") {
                this.loadMessageReceipient(messageSeq);
            }
        })
    }

    loadMessageReceipient(messageSeq) {

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_MESSAGE_RECEPIENTS",
            "message_seq": messageSeq
        }

        connector.postData(dataMap, (data) => { // success

            var selectedGroups = [];
            for (var i=0;i<data.data.length;i++) {
                const object = data.data[i];
                selectedGroups.push({name: object.post_to_name, id: object.post_to_seq});
            }

            var responsePopup = this.state.responsePopup;
            responsePopup.receipientList = selectedGroups;
            responsePopup.selectedReceipient = "";

            this.setState({
                responsePopup: responsePopup
            })
        }, (err_cd, msg, data) => { // failure
        });
    }

    closeResponsePopup() {

        var responsePopup = this.state.responsePopup;
        responsePopup.show = false;
        this.setState({responsePopup: responsePopup});
    }

    loadMessageInputs(studentSeq, index) {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_MESSAGE_INPUTS",
            "message_seq": this.state.responsePopup.messageSeq
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            var responsePopup = this.state.responsePopup;
            responsePopup.dataList[index].optionData = data.data;
            this.setState({responsePopup: responsePopup});

            this.loadResponseReply(studentSeq, index);

        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    loadResponseReply(studentSeq, index) {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        let dataMap = {
            "_action_code": "GET_MESSAGE_RESPONSE_DETAILS",
            "message_seq": this.state.responsePopup.messageSeq,
            "student_seq": studentSeq,
        }
        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            var responsePopup = this.state.responsePopup;
            responsePopup.dataList[index].responseData = data.data;
            this.setState({responsePopup: responsePopup});
            
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    downloadResponseData() {

        this.props.showPageSpinner(true);

        let connector = new ServerConnector();
        var dataMap = {
            "_action_code": "GET_MESSAGE_RESPONSE_XLS",
            "message_seq": this.state.responsePopup.messageSeq,
        }

        if (this.state.responsePopup.selectedReceipient != -1 && this.state.responsePopup.selectedReceipient.length > 0) {
            dataMap["set_seq"] = this.state.responsePopup.selectedReceipient;
        }

        connector.postData(dataMap, (data) => { // success

            this.props.showPageSpinner(false);

            window.open(data.data[0].file_path, '_blank', 'noreferrer');
            
        }, (err_cd, msg, data) => { // failure

            this.props.showPageSpinner(false);
            this.props.showAlert("Error", msg, "Ok", null, null);
        })
    }

    handleResponseFilterChange(setSeq) {
        var responsePopup = this.state.responsePopup;
        responsePopup.selectedReceipient = setSeq;
        this.setState({responsePopup: responsePopup});

        this.loadResponse(responsePopup.messageSeq, responsePopup.messageType, "reload", setSeq);
    }

    render() {

        return (
            <>
                <PageHeader page_name={this.props.page_name} >
                    <AppButton
                        color="primary"
                        name="Send Message"
                        icon={cilSend}
                        isLoading={false}
                        onClick={() => this.props.navigate("send_message", { message_seq: -999, messageType: "MESSAGE" })} />
                </PageHeader>
                {
                    this.state.spinner ?
                        <div className="spinnerHolder">
                            <CSpinner color="primary" />
                        </div>
                        : null
                }
                <CTable>
                    <CTableHead>
                        <CTableRow>
                            <CTableHeaderCell style={{ width: '60%' }} scope="col"> Message Text</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '25%' }} scope="col">Posted On</CTableHeaderCell>
                            <CTableHeaderCell style={{ width: '15%' }} scope="col">Actions</CTableHeaderCell>
                        </CTableRow>
                    </CTableHead>
                    <CTableBody>
                        {
                            this.state.dataList.map((object, index) => {
                                let menuList = [
                                    {
                                        name: "Edit",
                                        icon: cilPencil,
                                        isLoading: false,
                                        visible: true,
                                        onClick: () => { this.props.navigate("send_message", { message_seq: object.message_seq, messageType: object.message_type }) },
                                        data: null
                                    },
                                    {
                                        name: "Delete Message",
                                        icon: cilBan,
                                        isLoading: false,
                                        visible: true,
                                        onClick: () => { this.confirmDeleteMessage(object.message_seq) },
                                        data: null
                                    },
                                    {
                                        name: "View Response",
                                        icon: cilSearch,
                                        isLoading: false,
                                        visible: object.message_type == "MSG_POLL" || object.message_type == "MSG_FORM",
                                        onClick: () => { this.loadResponse(object.message_seq, object.message_type, "initial", -1) },
                                        data: null
                                    },
                                ];

                                return (
                                    <CTableRow key={String(object.message_seq)}>
                                        <CTableDataCell>
                                            {replaceEmpty(urlDecode(object.message))}
                                        </CTableDataCell>
                                        <CTableDataCell>{object.posted_on}</CTableDataCell>
                                        <CTableDataCell>
                                            <TableActions
                                                key={String(object.set_seq) + object.status}
                                                actions={menuList}
                                                minCount="1" />
                                        </CTableDataCell>
                                    </CTableRow>
                                )
                            })
                        }
                        {
                            this.state.dataList.length == 0 ?
                                <CTableRow>
                                    <CTableDataCell colSpan={5} className="alignCenter">No Data Available</CTableDataCell>
                                </CTableRow>
                                :
                                null
                        }
                    </CTableBody>
                </CTable>

                <Pagination
                    key={"pagination"+this.state.total_rows}
                    totalRows={this.state.total_rows}
                    displayedRowCount={this.state.dataList.length}
                    isDataLoading={this.state.isDataLoading}
                    onPageChange={(row) => {this.loadData(row)}} />

                {/* {
                    this.state.isLoadMore && this.state.dataList.length > 0 ?
                        <CCol md="12" style={{textAlign: "center"}}>
                            <AppButton
                                color="secondary"
                                name="Load More"
                                icon={cilReload}
                                isLoading={false}
                                onClick={() => this.setState({page_number: this.state.page_number + 1}, () => {this.loadData()})} />
                        </CCol>
                    : null
                } */}
                
                <CModal
                    visible={this.state.responsePopup.show}
                    onClose={() => { this.closeResponsePopup() }}
                    size="xl" >
                    <CModalHeader>
                        <CModalTitle>
                            Response
                        </CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                    <CTable className="linkSubjectTable">
                        <CTableBody>
                            <CTableRow>
                                <CTableDataCell colSpan={2} style={{textAlign: 'left'}}>
                                    <CFormLabel >Filter By Group</CFormLabel>
                                    <CFormSelect value={this.state.responsePopup.selectedReceipient}
                                        onChange={(event) => { this.handleResponseFilterChange(event.target.value) }}>
                                        <option value="">Select</option>
                                        {
                                            this.state.responsePopup.receipientList.map((object, index) => {
                                                return (
                                                    <option key={String(index) +"_" + object.id} value={object.id}>
                                                        {object.name}
                                                    </option>
                                                )
                                            })
                                        }
                                    </CFormSelect>
                                </CTableDataCell>
                                <CTableDataCell style={{textAlign: 'right'}}>
                                    {
                                        this.state.responsePopup.dataList.length > 0 ?
                                            <AppButton
                                                color="primary"
                                                name="Export To XLS"
                                                icon={cilCloudDownload}
                                                isLoading={false}
                                                onClick={() => {this.downloadResponseData()}} />
                                        : null
                                    }
                                </CTableDataCell>
                            </CTableRow>
                        </CTableBody>
                    </CTable>
                        {
                            this.state.responsePopup.progressData.map((object, index) => {

                                var percentage = 0;
                                if (this.state.responsePopup.totalProgress > 0) {
                                    var perc = object.count * 100 / this.state.responsePopup.totalProgress;
                                    percentage = Math.round(perc);
                                }

                                return(
                                    <>
                                        <CRow key={object.input_seq + "_optionreporttext"}>
                                            <CCol md={3}>
                                                {object.option_label}
                                            </CCol>
                                            <CCol md={3} style={{textAlign: 'right'}}>
                                                {object.count}
                                            </CCol>
                                        </CRow>
                                        <CRow key={object.input_seq + "_optionreport"}>
                                            <CCol md={6}>
                                                <CProgress className="mb-3">
                                                    <CProgressBar value={percentage}/>
                                                </CProgress>
                                            </CCol>
                                        </CRow>
                                    </>
                                );
                            })
                        }
                        <CTable className="linkSubjectTable">
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">Responded By</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Responded On</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Group</CTableHeaderCell>
                                    <CTableHeaderCell scope="col"></CTableHeaderCell>
                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {
                                    this.state.responsePopup.dataList.map((object, index) => {

                                        return(
                                            <>
                                                <CTableRow key={String(object.response_seq)}>
                                                    <CTableDataCell>{object.name}</CTableDataCell>
                                                    <CTableDataCell>
                                                        {object.responded_on}
                                                    </CTableDataCell>
                                                    <CTableDataCell>
                                                        {object.groups}
                                                    </CTableDataCell>
                                                    <CTableDataCell>
                                                        <TableActions
                                                            key={String(object.response_seq)}
                                                            actions={[
                                                                {
                                                                    name: "View",
                                                                    icon: cilSearch,
                                                                    isLoading: false,
                                                                    visible: true,
                                                                    onClick: () => { this.loadMessageInputs(object.student_seq, index) },
                                                                    data: null
                                                                },
                                                            ]}
                                                            minCount="1" />
                                                    </CTableDataCell>
                                                </CTableRow>
                                                {
                                                    this.state.responsePopup.messageType == "MSG_POLL" ?
                                                        object.responseData && object.responseData.length > 0 ?
                                                            <CTableRow>
                                                                <CTableDataCell colSpan={3}>
                                                                    <CTable color="dark">
                                                                        <CTableBody>
                                                                            {
                                                                                object.responseData.map((resp, respInd) => {
                                                                                    return(
                                                                                        <PollRow key={String(resp.response_seq) +"_"+respInd} resp={resp} />
                                                                                    );
                                                                                })
                                                                            }
                                                                        </CTableBody>
                                                                    </CTable>
                                                                </CTableDataCell>
                                                            </CTableRow>
                                                        : null
                                                    :
                                                        object.optionData && object.optionData.length > 0 ?
                                                                <CTableRow>
                                                                    <CTableDataCell colSpan={3}>
                                                                        <CTable color="dark">
                                                                            <CTableBody>
                                                                                {
                                                                                    object.optionData.map((option, optionIndex) => {
                                                                                        return(
                                                                                            <FormRow 
                                                                                                key={String(option.input_seq) + "_" + optionIndex} 
                                                                                                option={option}
                                                                                                responseData={object.responseData} />
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </CTableBody>
                                                                        </CTable>
                                                                    </CTableDataCell>
                                                                </CTableRow>
                                                            : null
                                                }
                                            </>
                                        );
                                    })
                                }
                            </CTableBody>
                        </CTable>
                    </CModalBody>
                </CModal>
            </>
        );
    }
}

function FormRow({option, responseData}) {

    var responseText = "";
    if (responseData) {
        responseData.map((object, index) => {

            if (option.input_seq == object.input_seq) {

                if (option.input_type == "TEXT") {

                    responseText = object.response[0];
                }
                else {
                    
                    for (var j=0;j<option.choices.length;j++) {

                        for (var i=0;i<object.response.length;i++) {

                            if (object.response[i] == option.choices[j].choice_seq) {
                                if (responseText.length != 0) {
                                    responseText += ", ";
                                }
                                responseText += option.choices[j].choice_label;
                            }
                        }
                    }
                }
            }
        });
    }

    if (responseText.length == 0) {
        responseText = "--";
    }

    return(
        <CTableRow>
            <CTableDataCell style={{fontWeight: 'bold', width: '30%'}}>{option.option_label}</CTableDataCell>
            <CTableDataCell style={{width: '70%'}}>{responseText}</CTableDataCell>
        </CTableRow>
    );
}

function PollRow({resp}) {

    return(
        <CTableRow>
            <CTableDataCell colSpan={2}>
                <CFormCheck
                    type="radio" 
                    inline 
                    name={resp.response_seq + "_option"} 
                    label={resp.option_label}
                    defaultChecked={resp.response[0] == "yes"}
                    disabled={false}/>
            </CTableDataCell>
        </CTableRow>
    );
}

export default MessagesList;